/*
 * Capable Health API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0.3
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.72
 *
 * Do not edit the class manually.
 *
 */
import ApiClient from '../ApiClient';
import LeadsidLead from './LeadsidLead';

/**
 * The LeadsIdBody model module.
 * @module model/LeadsIdBody
 * @version v0.3
 */
export default class LeadsIdBody {
  /**
   * Constructs a new <code>LeadsIdBody</code>.
   * @alias module:model/LeadsIdBody
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>LeadsIdBody</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/LeadsIdBody} obj Optional instance to populate.
   * @return {module:model/LeadsIdBody} The populated <code>LeadsIdBody</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new LeadsIdBody();
      if (data.hasOwnProperty('lead'))
        obj.lead = LeadsidLead.constructFromObject(data['lead']);
    }
    return obj;
  }
}

/**
 * @member {module:model/LeadsidLead} lead
 */
LeadsIdBody.prototype.lead = undefined;

